export default __webpack_public_path__ + "static/media/img_logo.4a30f561.png";